import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'regimen-preparation-banner',
  templateUrl: './regimen-prep.component.html',
  standalone: false,
})
export class RegimenPrepComponent {
  @Input('regimenClass')regimenClass: string;

  constructor(
    private router:Router,
  ) { }

  async handleClick():Promise<void> {
    this.router.navigate(['/user'], { queryParams: { tab: 'regimen', class: this.regimenClass } });
  }
}
